"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderHeadingSection = exports.Image = void 0;
var _litHtml = require("lit-html");
require("../../styles/HeadingSection.css");
var _HeadingEditDialog = require("./HeadingEditDialog");
var _textUtils = require("../../textUtils");
var _dateHelpers = require("./dateHelpers");
var _profileIcons = require("../../icons-svg/profileIcons");
var _contactIcons = require("../../icons-svg/contactIcons");
const renderHeadingSection = (context, subject, profileData, viewerMode, onSaved) => {
  const {
    name,
    pronouns,
    jobTitle,
    dateOfBirth,
    location,
    primaryPhone,
    primaryEmail,
    imageSrc
  } = profileData;
  const isOwner = viewerMode === 'owner';
  const phoneValue = (0, _textUtils.toText)(primaryPhone?.valueNode).replace(/^tel:/i, '');
  const emailValue = (0, _textUtils.toText)(primaryEmail?.valueNode).replace(/^mailto:/i, '');
  const dateOfBirthDisplay = (0, _dateHelpers.toDisplayDateDMY)((0, _textUtils.toText)(dateOfBirth), 'DD-MM-YYYY');
  return (0, _litHtml.html)`
      <section class="profile__section border-lighter" aria-labelledby="profile-name">
        <div class="profile__heading-top">
          <div class="profile__avatar">
            ${Image(imageSrc, name)}
          </div>
          <div class="profile__info">
            <header class="profile__header-bar mb-md">
              <div class="profile__identity" role="group" aria-label="Name and pronouns">
                <h1 id="profile-name" class="profile__name">${name}</h1>
                <span class="profile__pronouns">${pronouns ? `(${pronouns})` : ''}</span>
              </div>
              ${jobTitle ? (0, _litHtml.html)`<div class="profile__role-org">${jobTitle}</div>` : _litHtml.nothing}
            </header>
          </div>
          ${isOwner ? (0, _litHtml.html)`
              <div class="profile__actions profile__heading-actions" aria-label="Profile actions">
                <button
                  type="button"
                  class="profile__action-button profile__heading-action-button profile-action-text flex-center"
                  aria-label="Add or edit heading information"
                  @click=${event => {
    return (0, _HeadingEditDialog.createHeadingEditDialog)(event, context.session.store, subject, profileData, viewerMode, onSaved);
  }}
                >
                  <span class="profile-section-collapsible__edit-label">${_profileIcons.editIcon} Edit</span>
                  <span class="profile-section-collapsible__edit-icon" aria-hidden="true">${_profileIcons.editIcon}</span>
                </button>
              </div>
            ` : _litHtml.nothing}
          <div class="profile__details">
            <div class="profile__meta-row" role="group" aria-label="Additional profile information">
              ${Line(dateOfBirthDisplay, _profileIcons.birthdayIcon, '')}
              ${Line(location, _profileIcons.locationIcon, '')}
            </div>
            <div class="profile__contact-row" role="group" aria-label="Contact information">
              ${Line(phoneValue, _contactIcons.phoneIcon, '')}
              ${Line(emailValue, _contactIcons.emailIcon, '')}
            </div>
          </div>
        </div>
    </section>
  `;
};
exports.renderHeadingSection = renderHeadingSection;
const Line = (value, prefix = _litHtml.nothing, label = '') => value ? (0, _litHtml.html)`
    <div class="profile__item ${label ? '' : 'profile__item--valueOnly'}">
      ${label ? (0, _litHtml.html)`<span class="profile__label">${label}</span>` : _litHtml.nothing}
      <span class="profile__value">
        ${prefix !== '' && prefix !== _litHtml.nothing ? (0, _litHtml.html)`<span class="profile__prefix-icon" aria-hidden="true">${prefix}</span>` : _litHtml.nothing}
        <span class="profile__value-text">${value}</span>
      </span>
    </div>
  ` : _litHtml.nothing;
const Image = (src, alt) => src ? (0, _litHtml.html)`
        <img
          class="profile__hero"
          src=${src}
          alt="${alt}"
          width="140"
          height="140"
          loading="eager"
        />
      ` : (0, _litHtml.html)`
        <div class="profile__hero-alt flex-center" role="img" aria-label="${alt}" tabindex="0">
          <span class="profile__hero-icon">${_profileIcons.personInCircleIcon}</span>
        </div>
      `;
exports.Image = Image;